import { useCallback, useState } from 'react';

const DEFAULT_STATE = {
  show: false,
  title: '',
  message: '',
  confirmLabel: 'OK',
  confirmColor: '#451a03',
  showCancel: false,
  onConfirm: null,
};

/**
 * Tiny controller for the single AlertDialog instance PostForm renders.
 * `showAlert` takes an optional options bag matching `AlertDialog`'s
 * props (confirmLabel, confirmColor, showCancel, onConfirm); `hideAlert`
 * keeps the rest of the state intact so the dialog fades out with
 * consistent content.
 */
const useAlertDialog = () => {
  const [alertDialog, setAlertDialog] = useState(DEFAULT_STATE);

  const showAlert = useCallback((title, message, options = {}) => {
    setAlertDialog({
      show: true,
      title,
      message,
      confirmLabel: options.confirmLabel || 'OK',
      confirmColor: options.confirmColor || '#451a03',
      showCancel: options.showCancel || false,
      onConfirm: options.onConfirm || null,
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlertDialog((prev) => ({ ...prev, show: false }));
  }, []);

  return { alertDialog, showAlert, hideAlert };
};

export default useAlertDialog;
